// @flow
import type { Country } from '../country';
import { getPhoneNumberNormalizerWithLength } from '../../customer-form/get-phone-number-normalizer';

const KENYA: Country = {
  code: 'ke',
  customerForm: {
    phoneNumber: {
      normalizer: getPhoneNumberNormalizerWithLength(20),
    },
  },
};

export default KENYA;
